import { render, staticRenderFns } from "./almondco-freight-label-detail.vue?vue&type=template&id=415cf81e"
import script from "./almondco-freight-label-detail.vue?vue&type=script&lang=js"
export * from "./almondco-freight-label-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports